<template>
  <div id="ub-badge" class="badge" @click="this.handleSettings">
    {{ this.initials }}
  </div>
</template>

<script>
import { useIdentityStore } from '@/store/IdentityStore';
import { useModalStore } from '@/store/ModalStore';

export default {
  computed: {
    initials () {
      const user = useIdentityStore().User;
      return user ? user.initials : '';
    }
  },
  methods: {
    handleSettings () {
      useModalStore().showModal('settings');
    }
  }
};
</script>

<style>
.badge {
  aspect-ratio: 1/1;
  cursor: pointer;
  background-color: black;
  border-radius: 25px;
  color: white;
  text-align: center;
  font-size: 65%;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-right: 6px;
}
</style>